import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";

import {
  Collapse,
  Container,
  Navbar,
  Badge,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Modal,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardDeck,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from "reactstrap";

class NavbarApp extends Component {
  state = {
    isOpen: false,
    modal: false,
    open: false
  };
  handleOut = async event => {
    event.preventDefault();
    try {
      this.props.auth.setAuthStatus(false);
      this.props.auth.setUser(null);
      this.props.history.push("/");
    } catch (e) {
    }
  };
  toggle = () => {
    this.setState(prevState => ({
      // isOpen: !prevState.isOpen,
      //modal: !prevState.modal,
      open: !prevState.open
    }));
  };
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    return (
      <div>
        <Navbar color="dark" light className="navbar-transparent" expand="sm">
          <Container className="flex">
            <NavbarBrand className="text-white" to="/" tag={Link}>
              {" "}
              CalBit Portal{" "}
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <UncontrolledDropdown inNavbar className="">
                <DropdownToggle
                  className="text-white-50 text-white"
                  nav
                  caret
                  color="white"
                >
                  Fleet Inspections
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>Fleet Inspectors</DropdownItem>
                  <DropdownItem>Find Mechanics</DropdownItem>

                  <DropdownItem>Jobs</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <Nav className="ml-auto" navbar>
                <NavItem className=" py-2 ">
                  {this.props.auth.isAuthenticated && this.props.auth.user && (
                    <Badge color="light" className="py-2 mt-2">
                      {" "}
                      Hello, {this.props.auth.user}{" "}
                    </Badge>
                  )}
                </NavItem>
                <NavItem className=" py-2 ">
                  <NavLink className="text-white" to="/" tag={Link}>
                    How It Works
                  </NavLink>
                </NavItem>
                <NavItem className=" py-2">
                  <NavLink className="text-white" href="http://calbit.com">
                    Calbit.com
                  </NavLink>
                </NavItem>

                {!this.props.auth.isAuthenticated && (
                  <div>
                    <NavItem className=" py-2">
                      <Button
                        color="success"
                        className="text-white ml-2"
                        onClick={this.toggle}
                      >
                        Register
                      </Button>

                      <Dialog
                        fullWidth="true"
                        maxWidth="lg"
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Register
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            <CardDeck>
                              <Card className="">
                                <CardHeader
                                  style={{
                                    backgroundColor: "#4267B2",
                                    color: "white",
                                    fontWeight: "bold"
                                  }}
                                >
                                  Register As Customer
                                </CardHeader>
                                <CardBody>
                                  Manage your fleet DOT & BIT inspectios, get
                                  alerts for due inspections using our app, find
                                  top rated inspectors & mechanics, manage fleet
                                  maintenance using our platform.
                                  <div
                                    className="row"
                                    style={{ marginTop: 20 }}
                                  >
                                    <div className="col">
                                      <Button
                                        style={{
                                          backgroundColor: "#4267B2",
                                          color: "white",
                                          fontWeight: "bold"
                                        }}
                                        to="/reg/customer"
                                        tag={Link}
                                        onClick={this.toggle}
                                      >
                                        Register
                                      </Button>
                                    </div>
                                  </div>
                                </CardBody>
                                <CardFooter></CardFooter>
                              </Card>
                              <Card className="">
                                <CardHeader
                                  style={{
                                    backgroundColor: "#4D4D4D",
                                    color: "white",
                                    fontWeight: "bold"
                                  }}
                                >
                                  Resgiter As Inspector{" "}
                                </CardHeader>
                                <CardBody>
                                  <h5>
                                    Are you 396.19 DOT Qualified Inspector?
                                  </h5>
                                  <div
                                    className="row"
                                    style={{ marginTop: 10 }}
                                  >
                                    <div className="col">
                                      <Link
                                        style={{ fontWeight: "bold" }}
                                        to="/Inspector-Reg"
                                        onClick={this.toggle}
                                      >
                                        Yes I am, register me
                                      </Link>
                                    </div>
                                  </div>
                                  <div
                                    className="row"
                                    style={{ marginTop: 10 }}
                                  >
                                    <div className="col">
                                      <Link
                                        style={{ fontWeight: "bold" }}
                                        to="/Trainings"
                                        onClick={this.toggle}
                                      >
                                        No, I am not
                                      </Link>
                                    </div>
                                  </div>
                                  <div
                                    className="row"
                                    style={{ marginTop: 10 }}
                                  >
                                    <div className="col">
                                      <Link
                                        style={{ fontWeight: "bold" }}
                                        to="/IntrotoDOT"
                                        onClick={this.toggle}
                                      >
                                        I don't know
                                      </Link>
                                    </div>
                                  </div>
                                  <div
                                    className="row"
                                    style={{ marginTop: 20 }}
                                  >
                                    <div className="col">
                                      <Button
                                        style={{
                                          backgroundColor: "#4D4D4D",
                                          color: "white",
                                          fontWeight: "bold"
                                        }}
                                        to="/Inspector-Reg"
                                        tag={Link}
                                        onClick={this.toggle}
                                      >
                                        Register
                                      </Button>
                                    </div>
                                  </div>
                                </CardBody>
                                <CardFooter> </CardFooter>
                              </Card>
                              <Card className="">
                                <CardHeader
                                  style={{
                                    backgroundColor: "#1DA1F2",
                                    color: "white",
                                    fontWeight: "bold"
                                  }}
                                >
                                  Register As Vendor
                                </CardHeader>
                                <CardBody>
                                  Manage your fleet DOT & BIT inspectios, get
                                  alerts for due inspections using our app, find
                                  top rated inspectors & mechanics, manage fleet
                                  maintenance using our platform.
                                  <div
                                    className="row"
                                    style={{ marginTop: 20 }}
                                  >
                                    <div className="col">
                                      <Button
                                        style={{
                                          backgroundColor: "#1DA1F2",
                                          color: "white",
                                          fontWeight: "bold"
                                        }}
                                        to="/reg/vendor"
                                        tag={Link}
                                        onClick={this.toggle}
                                      >
                                        Register{" "}
                                      </Button>
                                    </div>
                                  </div>
                                </CardBody>
                                <CardFooter></CardFooter>
                              </Card>
                              <Card className="">
                                <CardHeader
                                  style={{
                                    backgroundColor: "#FFB900",
                                    color: "white",
                                    fontWeight: "bold"
                                  }}
                                >
                                  Register As Tire Vendor
                                </CardHeader>
                                <CardBody>
                                  Manage your fleet DOT & BIT inspectios, get
                                  alerts for due inspections using our app, find
                                  top rated inspectors & mechanics, manage fleet
                                  maintenance using our platform.
                                  <div
                                    className="row"
                                    style={{ marginTop: 20 }}
                                  >
                                    <div className="col">
                                      <Button
                                        style={{
                                          backgroundColor: "#FFB900",
                                          color: "white",
                                          fontWeight: "bold"
                                        }}
                                        to="/reg/tvendor"
                                        tag={Link}
                                        onClick={this.toggle}
                                      >
                                        {" "}
                                        Register{" "}
                                      </Button>
                                    </div>
                                  </div>
                                </CardBody>
                                <CardFooter></CardFooter>
                              </Card>
                            </CardDeck>
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            outline
                            onClick={this.handleClose}
                            color="secondary"
                          >
                            Cancel
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <Button
                        className="text-white ml-2"
                        color="success"
                        to="/login-page"
                        tag={Link}
                      >
                        SignIn
                      </Button>
                    </NavItem>
                  </div>
                )}

                {this.props.auth.isAuthenticated && (
                  <div>
                    <NavItem className=" py-2">
                      <Button
                        color="primary"
                        className="text-white"
                        onClick={this.handleOut}
                      >
                        SignOut
                      </Button>
                    </NavItem>{" "}
                  </div>
                )}
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </div>
    );
  }
}

export default NavbarApp;



// WEBPACK FOOTER //
// ./src/pages/Navbar.js